export default __webpack_public_path__ + "static/media/BoschSans-Regular-v5_003.346cae9c.ttf";